import Timestamp from "components/Timestamp";
import Link from "ds/components/Link";
import { TreeBranch, TreeBranchLink, TreeItem } from "ds/components/Tree";
import Typography from "ds/components/Typography";
import { RunDependency } from "types/generated";
import HistoryEntryWrapperSeparator from "components/Run/elements/HistoryEntryWrapper/Separator";
import RunStateBadge from "components/Run/elements/StateBadge";

type DependenciesEntryRunDependencyProps = {
  item: RunDependency;
};

const DependenciesEntryRunDependency = ({ item }: DependenciesEntryRunDependencyProps) => {
  return (
    <TreeBranch>
      <TreeBranchLink gap="medium" padding="small 0" align="center">
        <TreeItem autoHeight>
          <Typography variant="p-body3" tag="span" color="secondary">
            Run
          </Typography>
          <Link href={`/stack/${item.stackId}/run/${item.runId}`} size="small">
            {item.runId}
          </Link>
          <Typography variant="p-body3" tag="span" color="secondary">
            from stack
          </Typography>
          <Link href={`/stack/${item.stackId}`} size="small">
            {item.stackName}
          </Link>
          <RunStateBadge state={item.state} />
          <HistoryEntryWrapperSeparator margin="0" />
          <Timestamp color="secondary" timestamp={item.runUpdatedAt} />
        </TreeItem>
      </TreeBranchLink>
    </TreeBranch>
  );
};

export default DependenciesEntryRunDependency;
